var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.039,
    height: 13,
    viewBox: "0 0 12.039 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1.5,5.267A3.726,3.726,0,0,1,5.267,1.5,3.726,3.726,0,0,1,9.029,5.267,3.726,3.726,0,0,1,5.267,9.029,3.726,3.726,0,0,1,1.5,5.267Zm9.255,6.546a.745.745,0,0,0,1.053-1.053L9.481,8.427a5.152,5.152,0,0,0,1.053-3.16A5.235,5.235,0,0,0,5.267,0,5.235,5.235,0,0,0,0,5.267a5.235,5.235,0,0,0,5.267,5.267,5.152,5.152,0,0,0,3.16-1.053Z",
    fill: "#2699fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.f098b0cf53ce1b40fa0f08f97f5847b3.svg";
export { ForwardRef as ReactComponent };